import * as React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";

import { StoreState } from "../../store";
import ProtectedRoute from "./ProtectedRoute";
import { routeStatus } from "../../util/helperFunctions";

import Introduction from "../Introduction/Introduction";

const FarmDetails = React.lazy(() => import("../FarmDetails/FarmDetails"));
const MethodDiscovery = React.lazy(() =>
  import("../MethodDiscovery/MethodDiscovery")
);
const About = React.lazy(() => import("../About/About"));
const NextSteps = React.lazy(() => import("../NextSteps/NextSteps"));

type RouteComponent =
  | React.ComponentType<any>
  | React.LazyExoticComponent<React.ComponentType<any>>;

export enum Path {
  Root = "/",
  Introduction = "/introduction",
  FarmDetails = "/farmDetails",
  MethodDiscovery = "/methodDiscovery",
  About = "/about",
  NextSteps = "/nextSteps"
}

function toComponent(path: Path): RouteComponent {
  switch (path) {
    case Path.Root:
      return Introduction;
    case Path.Introduction:
      return Introduction;
    case Path.FarmDetails:
      return FarmDetails;
    case Path.MethodDiscovery:
      return MethodDiscovery;
    case Path.About:
      return About;
    case Path.NextSteps:
      return NextSteps;
    default:
      return Introduction;
  }
}

type Props = {
  methodDiscoveryStatus: boolean;
};

export const allPaths: Array<Path> = Object.values(Path);

const mapStateToProps = (state: StoreState) => routeStatus(state);

export function route(path: Path, props: Props) {
  switch (path) {
    case Path.MethodDiscovery:
      return (
        <Route exact key={path} path={path}>
          <ProtectedRoute
            shouldRoute={props.methodDiscoveryStatus}
            route={path}
            routeComponent={toComponent(path)}
            redirect={Path.FarmDetails}
          />
        </Route>
      );
    default:
      return (
        <Route exact key={path} path={path} component={toComponent(path)} />
      );
  }
}

const Routes: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <React.Suspense fallback={<div>Loading page…</div>}>
      <Switch>{allPaths.map(path => route(path, props))}</Switch>
    </React.Suspense>
  );
};

export default connect(mapStateToProps)(Routes);
